module.exports = __webpack_public_path__ + "img/rwgs-bg.614b22ed.png";